function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../../utils/high_contrast_media_query';
import typography from '../../utils/typography';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    hasDescription,
    isRTL
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => ({
    root: _objectSpread({
      alignItems: 'flex-start',
      borderRadius: theme.borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      boxSizing: 'border-box',
      display: 'flex',
      fontFamily: theme.typography.family0,
      padding: isRTL ? "0 calc(".concat(theme.orbitalThree, " - 1px) 0 calc(").concat(theme.orbitalTwo, " - 1px)") : "0 calc(".concat(theme.orbitalTwo, " - 1px) 0 calc(").concat(theme.orbitalThree, " - 1px)"),
      width: '100%'
    }, highContrastMediaQuery(theme)),
    action: {
      margin: "calc(".concat(theme.orbitalTwo, " - 2px) 0")
    },
    closeButton: {
      margin: "".concat(theme.orbitalTwo, " 1px ").concat(theme.orbitalTwo, " 0px")
    },
    title: _objectSpread(_objectSpread({
      display: 'flex',
      flex: '1',
      flexDirection: 'column',
      margin: "calc(".concat(theme.orbitalThree, " - 1px) ").concat(theme.orbitalThree, " calc(").concat(theme.orbitalThree, " - 1px) ").concat(theme.orbitalOne),
      wordBreak: 'break-word'
    }, typography(theme).label), {}, {
      minHeight: hasDescription ? "calc(".concat(theme.layout.size6, " + ").concat(theme.layout.size4, ")") : theme.layout.size6,
      justifyContent: 'center'
    })
  }), [hasDescription, isRTL, theme]);
};
export default useStyles;